"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const luxon_1 = require("luxon");
const selectPunchUtils_1 = require("../selectPunchUtils");
const hooks_1 = require("../../../../../hooks");
const context_1 = require("../../../context");
const PunchWorkflowTypes_1 = require("../../../PunchWorkflowTypes");
const consts_1 = require("../../../../../consts");
const useSelectPunch = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { selectedDateTime, associateInfo, selectedPunchList, action, editPunchLockoutStatus, setCurrentStepTitle, setIsCurrentStepValid, setTotalSteps, setSelectedPunchTime, setEditPunchLockoutStatus, setShowErrorFallback } = (0, context_1.usePunchWorkflowContext)();
    (0, react_1.useEffect)(() => {
        setCurrentStepTitle(t('time_and_attendance_PunchWorkflow_SelectPunchStep_Title'));
        setIsCurrentStepValid(false);
        setSelectedPunchTime(undefined);
    }, []);
    (0, react_1.useEffect)(() => {
        if (action === PunchWorkflowTypes_1.PUNCH_WORKFLOW_ACTIONS.DELETE) {
            setTotalSteps(4);
        }
    }, [action, setTotalSteps]);
    const { data: { editPunchLockoutStatus: newEditPunchLockoutStatus } = {}, isLoading, isError: isEditPunchLockoutStatusError, isSuccess: isEditPunchLockoutStatusSuccess } = (0, hooks_1.useEditPunchLockoutStatus)({
        employeeId: associateInfo === null || associateInfo === void 0 ? void 0 : associateInfo.employeeId,
        shouldFetch: action === PunchWorkflowTypes_1.PUNCH_WORKFLOW_ACTIONS.EDIT &&
            editPunchLockoutStatus === undefined,
        usageLocation: consts_1.featureNames.PUNCH_WORKFLOW_FEATURE
    });
    (0, react_1.useEffect)(() => {
        if (isEditPunchLockoutStatusSuccess) {
            setEditPunchLockoutStatus(newEditPunchLockoutStatus);
        }
    }, [isEditPunchLockoutStatusSuccess]);
    (0, react_1.useEffect)(() => {
        if (isEditPunchLockoutStatusError) {
            setShowErrorFallback(true);
            setTotalSteps(3);
        }
    }, [isEditPunchLockoutStatusError]);
    const localizedSelectedDate = selectedDateTime.toLocaleString(luxon_1.DateTime.DATE_FULL);
    const [eligiblePunches, ineligiblePunches] = (0, selectPunchUtils_1.processPunchesByEligibility)(selectedPunchList, action, editPunchLockoutStatus);
    return {
        localizedSelectedDate,
        eligiblePunches,
        ineligiblePunches,
        isLoading
    };
};
exports.default = useSelectPunch;
